var Paginator = (function($) {
    function initialize() {
        $("#items-per-page").on('change', function(){
            window.location.href = $(this).val();
        })
    }

    return {
        initialize:initialize
    }
})($);

$(function() {
    Paginator.initialize();
});